import sidebarConfig from '@/multi-territory/mt-configs/sidebar-config.json'
import { useMemo } from 'react'

// Temporary adapter for the future sidebar API response.
export const getSidebarResponse = countryCode => {
  const configurationName =
    sidebarConfig.countryConfiguration[countryCode] ||
    sidebarConfig.defaultConfiguration

  return {
    success: true,
    data: {
      countryCode,
      modules: sidebarConfig.configurations[configurationName] || [],
    },
  }
}

export const useSidebarConfig = (countryCode, userRole) =>
  useMemo(() => {
    const response = getSidebarResponse(countryCode)
    return response.data.modules
      .filter(module => module.roles.includes(userRole))
      .sort((first, second) => first.order - second.order)
  }, [countryCode, userRole])
